import { values } from 'lodash';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseDialPhoneError } from './communications-response-dial-phone-error';

export class CommunicationsResponseDialPhoneSchema extends CommunicationsResponseSchema {
  public static readonly outboundCallSessionId = 'outboundCallSessionId';

  public static readonly outboundCallSessionEventId = 'outboundCallSessionEventId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly error = undefined;

    public static readonly outboundCallSessionId = undefined;

    public static readonly outboundCallSessionEventId = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationsResponseDialPhoneSchema.error] = SchemaField.string(
      CommunicationsResponseSchema.Defaults.error,
    )
      .optional()
      .valid(...values(CommunicationsResponseDialPhoneError));
    parameters[CommunicationsResponseDialPhoneSchema.outboundCallSessionId] = SchemaField.autoGeneratedDocId(
      CommunicationsResponseDialPhoneSchema.Defaults.outboundCallSessionId,
    ).optional();
    parameters[CommunicationsResponseDialPhoneSchema.outboundCallSessionEventId] = SchemaField.autoGeneratedDocId(
      CommunicationsResponseDialPhoneSchema.Defaults.outboundCallSessionEventId,
    ).optional();
    /* eslint-enable */

    return parameters;
  }
}
